import { graphql } from '@/gql'

export const CreateNoteMutation = graphql(/* GraphQL */ `
  mutation CreateNoteMutation($input: CreateNoteInput!) {
    createNote(input: $input) {
      ...NoteViewFragment
    }
  }
`)
